export default __webpack_public_path__ + "static/media/utr.e004d593.svg";